import { CustomThemeType } from '../Types';

export const lightTheme: CustomThemeType = {
  //! to be changed
  mode: 'dark',

  colors: {
    main: {
      primary: {
        lightest: '#e8e8ee',
        lighter: '#a5a3bb',
        light: '#4a4678',
        normal: '#1d1856',
        dark: '#171345',
        darker: '#110e34',
        darkest: '#09071a',
      },
      secondary: {
        lightest: '#f9e6fb',
        lighter: '#e799f1',
        light: '#d44de6',
        normal: '#c200db',
        dark: '#9b00af',
        darker: '#740083',
        darkest: '#3a0042',
      },
      detail: {
        lightest: '#e6fafc',
        lighter: '#b3f1f7',
        light: '#80e7f2',
        normal: '#00cfe5',
        dark: '#007c89',
        darker: '#003e45',
        darkest: '#001517',
      },
      effect: {
        lightest: '#fde6f1',
        lighter: '#f8b3d5',
        light: '#f480ba',
        normal: '#e80074',
        dark: '#a20051',
        darker: '#74003a',
        darkest: '#460023',
      },
    },
    feedback: {
      error: {
        lightest: '#333333',
        lighter: '#333333',
        light: '#333333',
        normal: '#333333',
        dark: '#333333',
        darker: '#333333',
        darkest: '#333333',
      },
      warning: {
        lightest: '#333333',
        lighter: '#333333',
        light: '#333333',
        normal: '#333333',
        dark: '#333333',
        darker: '#333333',
        darkest: '#333333',
      },
      info: {
        lightest: '#333333',
        lighter: '#333333',
        light: '#333333',
        normal: '#333333',
        dark: '#333333',
        darker: '#333333',
        darkest: '#333333',
      },
      success: {
        lightest: '#333333',
        lighter: '#333333',
        light: '#333333',
        normal: '#333333',
        dark: '#333333',
        darker: '#333333',
        darkest: '#333333',
      },
    },
    grayscale: {
      lightest: '#333333',
      lighter: '#333333',
      light: '#333333',
      normal: '#333333',
      dark: '#333333',
      darker: '#333333',
      darkest: '#333333',
    },
    common: {
      black: '#000000',
      white: '#ffffff',
    },
    background: {
      default: {
        lightest: '#09071a',
        lighter: '#110e34',
        light: '#171345',
        normal: '#1d1856',
        dark: '#4a4678',
        darker: '#a5a3bb',
        darkest: '#e8e8ee',
      },
      highContrast: {
        lightest: '#e8e8ee',
        lighter: '#a5a3bb',
        light: '#4a4678',
        normal: '#1d1856',
        dark: '#171345',
        darker: '#110e34',
        darkest: '#09071a',
      },
    },
    font: {
      primary: '#110e34',
      secondary: '#740083',
      detail: '#003e45',
      effect: '#74003a',
      error: '#333333',
      warning: '#333333',
      info: '#333333',
      success: '#333333',
      white: '#ffffff',
      black: '#000000',
      default: '#333333',
      caption: '#555',
      hint: '#777777',
      disabled: '#aaaaaa',
    },
  },

  borders: {
    width: {
      MD: 1,
      LG: 2,
      XL: 4,
      XL2: 8,
    },
    radius: {
      SM: 2,
      MD: 4,
      LG: 8,
      XL: 16,
      pill: 500,
      rounded: '50%',
    },
  },

  typographies: {
    h1: {
      fontFamily: 'Courier New',
      fontSize: '3rem',
      fontWeight: 'bold',
      lineHeight: '4rem',
    },
    h2: {
      fontFamily: 'Courier New',
      fontSize: '2rem',
      fontWeight: 'bold',
      lineHeight: '2.67rem',
    },
    h3: {
      fontFamily: 'Courier New',
      fontSize: '1.67rem',
      fontWeight: 'bold',
      lineHeight: '2.17rem',
    },
    h4: {
      fontFamily: 'Courier New',
      fontSize: '1.33rem',
      fontWeight: 'bold',
      lineHeight: '1.83rem',
    },
    h5: {
      fontFamily: 'Courier New',
      fontSize: '1rem',
      fontWeight: 'normal',
      lineHeight: '1.33rem',
    },
    h6: {
      fontFamily: 'Courier New',
      fontSize: '0.83rem',
      fontWeight: 'normal',
      lineHeight: '1rem',
    },
    subtitle1: {
      fontFamily: 'Courier New',
      fontSize: '1.33rem',
      fontWeight: 'bold',
      lineHeight: '1.83rem',
    },
    subtitle2: {
      fontFamily: 'Courier New',
      fontSize: '1rem',
      fontWeight: 'normal',
      lineHeight: '1.33rem',
    },
    subtitle3: {
      fontFamily: 'Courier New',
      fontSize: '0.83rem',
      fontWeight: 'normal',
      lineHeight: '1rem',
    },
    body1: {
      fontFamily: 'Arial',
      fontSize: '1rem',
      fontWeight: 'normal',
      lineHeight: '1.33rem',
    },
    body2: {
      fontFamily: 'Arial',
      fontSize: '0.83rem',
      fontWeight: 'normal',
      lineHeight: '1rem',
    },
    link: {
      fontFamily: 'Arial',
      fontSize: '1rem',
      fontWeight: 'normal',
      lineHeight: '1.33rem',
    },
    button: {
      fontFamily: 'Courier New',
      fontSize: '1rem',
      fontWeight: 'bold',
      lineHeight: '1rem',
    },
  },

  opacities: undefined,
  shadows: undefined,
  spacings: undefined,
  acessibilities: undefined,
  animations: undefined,
};
